import React, { useState, useEffect } from 'react'

interface AccessPermissionItemProps {
   onPermissionChange: (permission: 'yes' | 'no' | null) => void
   defaultPermission?: 'yes' | 'no' | null
}

export const AccessPermissionItem: React.FC<AccessPermissionItemProps> = ({
   onPermissionChange,
   defaultPermission = null,
}) => {
   const [selectedPermission, setSelectedPermission] = useState<
      'yes' | 'no' | null
   >(defaultPermission)

   useEffect(() => {
      setSelectedPermission(defaultPermission)
   }, [defaultPermission])

   const handlePermissionSelect = (permission: 'yes' | 'no' | null) => {
      setSelectedPermission(permission)
      onPermissionChange(permission)
   }

   return (
      <div className="flex items-center gap-2 ml-4">
         <p className="text-[14px] opacity-70 mr-5">Whitelist Agent</p>
         <div className="flex items-center gap-2">
            <button
               onClick={() => {
                  handlePermissionSelect('yes')
               }}
               className={`px-3 py-1 text-sm rounded border transition-all ${
                  selectedPermission === 'yes'
                     ? 'bg-success/20 border border-success rounded text-white'
                     : 'bg-black/10 hover:bg-black/20 text-white/70'
               }`}
            >
               Yes
            </button>
            <button
               onClick={() => {
                  handlePermissionSelect('no')
               }}
               className={`px-3 py-1 text-sm rounded border transition-all ${
                  selectedPermission === 'no'
                     ? 'bg-[#E72538]/20 text-white border-[#E72538]/50'
                     : 'bg-black/10 hover:bg-black/20 text-white/70'
               }`}
            >
               No
            </button>
         </div>
      </div>
   )
}
